import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { toTitleCase } from "../../utils/common";

const PPEChart = ({ statsData }) => {
  let { width } = useWindowDimensions();
  const chartData = {
    series: [
      {
        name: "Violations",
        data: Object?.values(statsData?.violation || {}),
      },
      {
        name: "Non-Violations",
        data: Object?.values(statsData?.nonViolation || {}),
      },
    ],
    options: {
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      colors: ["#ca373c", "#333333"],
      plotOptions: {
        bar: {
          borderRadius: 5,
          borderWidth: 1,
          columnWidth: "50%",
        },
      },
      stroke: {
        show: true,
        width: 4,
        colors: ["transparent"],
      },
      xaxis: {
        categories: Object.keys(statsData?.violation || {}).map((item) => {
          if (item.toLowerCase() === "vest") {
            return toTitleCase("safety vest");
          }
          return toTitleCase(item);
        }),
      },
      dataLabels: {
        enabled: false,
      },
    },
  };

  return (
    <>
      <div id="chart" className="pt-1">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={width > 1400 && width < 1700 ? 235 : width >= 1700 ? 320 : 207}
        />
      </div>
    </>
  );
};

export default PPEChart;
